import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor( private swUpdate: SwUpdate, private languageService: LanguageService) {
    // this.checkForUpdates();
    this.inicializaApp();
  }


  checkForUpdates() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        console.log('event', event);
        if (event.type === 'VERSION_READY') {
          /* console.log('Nueva versión disponible. Refrescando caché...');
          window.location.reload(); // Fuerza el refresco de toda la app */

          if (confirm('Hay una nueva versión disponible. ¿Deseas actualizar?')) {
            window.location.reload();
          }
        }
      });
    }
  }

  
  inicializaApp() {
    this.languageService.setInitialAppLanguage();
  }
}
